
// src/connects/left-sidebar.js

import { connect } from 'react-redux'
import actions from '../actions'
import ui from '../helpers/ui-state'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { pushRoute } from '../actions/route'
import filter from 'lodash/filter'
import reduce from 'lodash/reduce'
import _ from'lodash'
import { translate } from 'react-i18next'
import { sortArray, stripArray } from '../helpers/store'
import GroupIdStore from '../actions/group-id-store'
import savedTempSearchQuery from '../actions/save-search-query-temp'

export const mapStateToProps = (state)=> {
  return {
    search: state.groups.search,
    organizations: state.organizations.items,
    groups: state.groups.items,
    divisions: state.divisions.items,
    user: state.user.current,
    active: state.sidebar.open,
    reloadNeeded: state.buildNo.reloadNeeded,
    routes: state.routes,
    isSaving: state.savedDiaries.isPosting,
    chatUnreadCount: state.chatRooms.unreadCount,
    latest: state.announce.latest,
    close: state.announce.close,
    currentDivisionId: state.divisions.currentId,
    menuItems: state.menus.items,
    userMenuItems: state.user && state.user.current ? state.user.current.menu_items : null,
    expandedDivisions: state.menus.expandedDivisions,
    canExpandDivNotSetGroup: state.menus.canExpandDivNotSetGroup,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var groups = stateProps.groups
  var divisions = stateProps.divisions

  if (stateProps.search)
    groups = filter(groups, (group)=> { return !group.is_free_group || group.name.indexOf(stateProps.search) > -1 })
    divisions = filter(divisions, (division) => {
      if (division.name.indexOf(stateProps.search || '') > -1) {
        return division;
      }
      const divisionGroups = division.groups.filter((group)=> { return group.name.indexOf(stateProps.search || '') <= -1 })
      groups = groups.filter((group)=> {
        return divisionGroups.filter((g)=> {return g.name == group.name}).length === 0
      })
      return division;
    })

    var memberGroups = filter(groups, (group)=> {
      return (group.is_member || group.favorite)
    })

    let unreadGroupsCount = reduce(memberGroups, (sum, group)=> {
      if(group.unreadCount > 0){
        sum += group.unreadCount
      }
      return sum
    }, 0)

    let unreadGroups = filter(memberGroups, (group) => {
        return group.unreadCount > 0 && group
    })

    var otherGroups = filter(groups, (group)=> {
      return group.can_read && !group.is_member && !group.favorite
    })

  return {
    ...stateProps, ...dispatchProps, ...ownProps,
    MemberGroups: stripArray(memberGroups),
    publicOtherGroups: stripArray(otherGroups),
    unreadGroupsCount: unreadGroupsCount,
    unreadGroups: unreadGroups,
    divisions: divisions
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    selectGroup: (group_id, props)=> {
      if (props && props.isSaving) return  // 一時保存中はグループ切り替えを禁止
      dispatch(actions.closeSidebar())
      if (group_id == 'home') {
        GroupIdStore.clear()
        pushRoute('home_group')
      }
      else {
        GroupIdStore.set(group_id)
        pushRoute('group_timeline', { group_id })
      }
    },
    selectDivision: (division_id, props)=> {
      if (props && props.isSaving) return  // 一時保存中はグループ切り替えを禁止
      dispatch(actions.closeSidebar())
      GroupIdStore.clear()
      pushRoute('division_group', { division_id })
    },
    selectDivisionNotSetGroup: (division_id, props)=> {
      if (props && props.isSaving) return  // 一時保存中はグループ切り替えを禁止
      dispatch(actions.closeSidebar())
      GroupIdStore.clear()
      if (division_id === 'new') {
        pushRoute('division_not_set_group', { division_id })
      }
    },


    selectOrganization: (organization_id)=> {
      dispatch(actions.closeSidebar())
      dispatch(actions.closeRightSidePage())
      dispatch(actions.clearDiaries())
      pushRoute('organization', { organization_id })
    },

    onSearchChange: (query)=> {
      dispatch(actions.searchGroups(query))
    },

    openUserSettingsPage: ()=> {
      dispatch(actions.closeSidebar())
      dispatch(actions.openUserSettingsPage())
    },
    openSortGroup: ()=> dispatch(actions.openUserSettingsPage('groupSorting')),

    openSidebar: ()=> dispatch(actions.openSidebar()),

    openAnnouncePage: ()=> dispatch(actions.openRightSidePage('notifications', { group_id: 'home', tabIndex: 1, from: 'announceButton' })),

    closeSidebar: ()=> dispatch(actions.closeSidebar()),

    closeAnnounce: ()=> dispatch(actions.closeAnnounce()),

    openAnnounce: ()=> dispatch(actions.openAnnounce()),

    requestConfirmationMail: ()=> dispatch(actions.requestConfirmationMail()),

    openChatRooms: ()=> dispatch(actions.openRightSidePage('chat_rooms', { from: 'chatButton'})),

    didMount: (props)=> {
      dispatch(actions.initMenus(props.userMenuItems, props.divisions, props.groups))
    },

    willMount: (props) => {
      dispatch(actions.initMenus(props.userMenuItems, props.divisions, props.groups))
    },

    willUpdate: (props, nextProps)=> {
      // Filter the userMenuItems array with type "group" to get user's groups
      const user_groups = (nextProps.userMenuItems || []).filter(item => item.type == 'group')
      if ((user_groups.length > 0 && nextProps.menuItems.length == 0)
        || !_.isEqual(props.divisions, nextProps.divisions)
        || !_.isEqual(props.groups, nextProps.groups))
        dispatch(actions.initMenus(nextProps.userMenuItems, nextProps.divisions, nextProps.groups))
      if (!_.isEqual(props.menuItems, nextProps.menuItems))
        dispatch(actions.updateUserMenuItems(nextProps.menuItems))
    },

    expandDivision: (division_id) => {
      dispatch(actions.expandDivision(division_id))
    },
    collapseDivision: (division_id) => {
      dispatch(actions.collapseDivision(division_id))
    },
    expandDivisionNotSetGroup: ()=> {
      dispatch(actions.expandDivisionNotSetGroup())
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: {
    active: false,
    isFilter: false,
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/left-sidebar.js